import { Component } from "@angular/core";

@Component({
  selector: "dynamic-component",
  template: ""
})
export class DynamicComponent {}
